const state = {
    types : window.APPDATA.exam_types,
}

const mutations = {
    SET_TYPES(state, types) {
        state.types = types;
    },
}

const actions = {
    getTypes({ commit, state }, params) {
        return this._vm.$http.post(this.getters.urls.api.exam.view, params).then((response) => {
            if(response.data.status) {
                commit('SET_TYPES', response.data.data.types);
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },
}

const getters = {
    types: (state, getters) => {
        return state.types;
    },
    typesNormal: (state, getters) => {
        return _.filter(state.types, (type) => {
            return [1,2,3,5].includes(type.id);
        });
    },
    typesPei: (state, getters) => {
        return _.filter(state.types, (type) => {
            return [4,6].includes(type.id);
        });
    },
    chaptersByTypeId: (state, getters) => (exam_type_id) => {
        let type = _.find(state.types, ['id', parseInt(exam_type_id)]);

        return _.get(type, 'reference_to.chapters', []);
    },
}

export default {
    state,
    actions,
    mutations,
    getters,
}